import { asyncStoreGet, asyncStoreClear } from '../../ui/Utils/asyncStorage'; // adjust path
import { TOKEN_KEY } from '../../ui/contants/authKeys';

/**
 * Enhanced Fetch function with proper JSON parsing and error handling
 */
export const Fetch = async (
    url,
    method = 'GET',
    headers = {},
    params = null,
    screenName = "defaultScreen",
    showResponse = false
) => {
    try {
        // Default headers
        const defaultHeaders = {
            'Content-Type': 'application/json',
            ...headers
        };

        // attach token if present
        const token = await asyncStoreGet(TOKEN_KEY);
        if (token) defaultHeaders['Authorization'] = `Bearer ${token}`;

        // send cookies to API (used when backend sets HttpOnly cookie)
        const fetchParams = {
            method: method.toUpperCase(),
            headers: defaultHeaders,
            // credentials: 'include'  // sends cookies
        };

        // Add body for POST/PUT etc., not GET
        if (params && method.toUpperCase() !== 'GET') {
            fetchParams.body = typeof params === 'string' ? params : JSON.stringify(params);
        }

        console.log(`[${screenName}] ${method} ${url}`, { params });

        const response = await fetch(url, fetchParams);

        // Read response body once as text, then try JSON.parse; fallback to raw text
        let text;
        try {
            text = await response.text();
        } catch (e) {
            console.warn('[Fetch] Failed to read response as text', e);
            text = '';
        }

        let parsed;
        try {
            parsed = text ? JSON.parse(text) : null;
        } catch (e) {
            // Not JSON — keep raw text
            parsed = text;
        }

        // If unauthorized, clear stored auth and return a legacy-friendly object
        if (response.status === 401) {
            const body = parsed || { message: 'Unauthorized' };
            try {
                await asyncStoreClear();
                console.debug('[Fetch] 401 received - cleared stored auth_token');
            } catch (e) {
                console.warn('[Fetch] failed to clear storage on 401', e);
            }
            return {
                success: false,
                status: 401,
                error: 'Unauthorized',
                response: body,
                // provide text() for legacy callers that expect Response.text()
                text: async () => (typeof body === 'string' ? body : JSON.stringify(body)),
            };
        }

        // Normalize backend success shape where backend returns { code: 0, data: ... }
        if (parsed && parsed.code === 0) {
            console.log(`[${screenName}] Success:`, parsed);
            const body = parsed;
            return {
                success: true,
                data: body.data,
                response: body,
                status: response.status || 200,
                // legacy compatibility: return the raw JSON string when text() is called
                text: async () => JSON.stringify(body),
            };
        }

        // Backend returned an error-ish payload (non-zero code)
        const body = parsed || { message: 'API Error' };
        console.error(`[${screenName}] Backend Error:`, body.message || body);
        return {
            success: false,
            error: body.message || 'API Error',
            response: body,
            status: response.status || 500,
            text: async () => (typeof body === 'string' ? body : JSON.stringify(body)),
        };

    } catch (error) {
        console.error(`[${screenName}] Fetch Error:`, error.message);
        
        // Network errors return consistent format
        return {
            success: false,
            error: error.message,
            status: 999
        };
    }
};
